// Tracks the beat of the current song: server tempo map + optional phase-lock to real kicks from an analyser.
export class BeatClock {
  constructor() {
    this.np = null;
    this.syncAt = 0;
    this.adj = 0;
    this.trackId = null;
    this.energyAvg = 0;
    this.lastOnset = 0;
    this.latency = 0;
  }

  setStatus(np, syncAt) {
    if (np?.id !== this.trackId) { this.adj = 0; this.trackId = np?.id; }
    this.np = np;
    this.syncAt = syncAt;
  }

  bpm() { return this.np?.bpm_now || this.np?.bpm || 0; }

  position(now = performance.now()) {
    const bpm = this.bpm() || 90;
    const heard = (this.np?.elapsed || 0) + (now - this.syncAt) / 1000 - this.latency;
    const ref = this.np?.beat_ref ?? this.np?.beat_offset ?? 0;
    return (heard - ref) / (60 / bpm) + this.adj;
  }

  // bass: 0..255 low-frequency energy from an analyser; nudges phase toward detected kicks
  feed(bass, now = performance.now()) {
    this.energyAvg = this.energyAvg * 0.95 + bass * 0.05;
    const period = 60000 / (this.bpm() || 90);
    if (bass > 40 && bass > this.energyAvg * 1.3 && now - this.lastOnset > period * 0.5) {
      this.lastOnset = now;
      const pos = this.position(now);
      const frac = pos - Math.round(pos);
      this.adj -= frac * 0.2;
    }
  }

  pulse(now) {
    const pos = this.position(now);
    const frac = pos - Math.floor(pos);
    return { pulse: Math.exp(-frac * 6), beat: Math.floor(pos), frac };
  }
}
